import { Box } from '@factorialco/deprecated-design-system'
import { F0TableOfContent } from '@factorialco/f0-react/dist/experimental'
import { Delete } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

type NavigationPage = {
  id: number
  title: string
}

interface PagesNavigationProps {
  pages: NavigationPage[]
  activeItem?: string
  onItemClick: (id: string) => void
  onDeletePage: (pageId: number) => void
  visitedPageIndices: Set<number>
}

export const PagesNavigation = ({
  pages,
  activeItem,
  onItemClick,
  onDeletePage,
  visitedPageIndices,
}: PagesNavigationProps) => {
  const items = pages.map((page, index) => {
    const isVisited = visitedPageIndices.has(index)
    return {
      id: page.id.toString(),
      label: page.title,
      onClick: () => onItemClick(page.id.toString()),
      disabled: !isVisited,
      otherActions: [
        {
          label: i18n.t('pages.upload_files_modal.preview.delete_page'),
          icon: Delete,
          onClick: () => onDeletePage(page.id),
        },
      ],
    }
  })

  return (
    <Box height="full" width="fit-content" flexNoShrink>
      <F0TableOfContent
        activeItem={activeItem}
        items={items}
        title={i18n.t('pages.upload_files_modal.preview.uploaded_documents')}
      />
    </Box>
  )
}
